var AOS = require('aos');
var $ = require('jquery');

module.exports = {
	init: function () {
        $('.block .wrapper').each(function(){
            $(this).attr('data-aos', 'fade-up');
        });
        AOS.init();
	}
}